<template>
  <div class="cart">
    <div class="cart__wrapper">
      <SiteNav></SiteNav>
      <div class="cart__content">
        <div class="cart__title">
          {{ $store.getters.language.review_cart }}
        </div>
        <div class="cart__description">
          {{ this.$store.getters.language.review_description }}
        </div>
        <div class="cart__items">
          <LineItems v-if="lineItems" :lineItems="lineItems" :editDates="true" @updateItems="getCartItems()"></LineItems>

        </div>
        <ButtonBar :centered="true">
          <ButtonSecondary type="router" link="/search" :title="this.$store.getters.language.add_more_spaces">{{ this.$store.getters.language.add_more_spaces }}</ButtonSecondary>
          <ButtonPrimary :title="this.$store.getters.language.continue" type="link" link="/pitches/enquire">{{ this.$store.getters.language.continue }}</ButtonPrimary>
        </ButtonBar>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import SiteNav from "../../components/global/SiteNav"
import LineItems from '../../components/pitch/LineItems'
import ButtonBar from '../../components/pitch/ButtonBar'
import SuggestedSpaces from "../../components/pitch/SuggestedSpaces"
import ButtonPrimary from "../../components/global/ButtonPrimary"
import ButtonSecondary from "../../components/global/ButtonSecondary"
import Checkbox from "../../components/global/Checkbox"

import gql from 'graphql-tag'

export default {
  name: 'Centre',
  data: () => ({
    lineItems: null,
    isChecked: false,
    showModal: false
  }),
  components: {
    SiteNav,
    LineItems,
    SuggestedSpaces,
    ButtonPrimary,
    ButtonSecondary,
    ButtonBar,
    Checkbox
  },
  watch: {
  },
  mounted () {
    this.getCartItems()
  },
  created () {
  },
  methods: {
    getCartItems () {
      var self = this
      axios
          .get('/api/pitches/users_bookings')
          .then(response => {
            if (response.data.no_user) {
              window.location.href = '/users/sign_in';
            } else {
              self.lineItems = response.data.items.bookings
            }
          })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";
@import '../../scss/global/fonts.scss';

.cart {
  color: $primary-grey;
  line-height: 1.4;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
}

.cart__wrapper {
  max-width: 1298px;
  margin-top: 70px;
  padding: 0 16px;
  width: 100%;
}

.cart__items {
  width: 100%;
}

.cart__content {
  width: 100%;
  display: flex;
  gap: 40px; 
  flex-wrap: wrap;
  padding-top: 56px;
}

.cart__title {
  text-align: center;
  width: 100%;
  @include responsive-text-size('Header--18--Bold');
}

.cart__description {
  text-align: center;
  width: 100%;
  @include responsive-text-size('Title--18--Regular');
}

</style>
